var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { showDirectoryTreeDialog } from '../../features/file-manager';
// eslint-disable-next-line no-restricted-imports
import { restoreFile } from '../../features/file-manager/utils/restoreFile';
import { showFileExistsDialog } from './showFileExistsDialog';
import { showReviewAccessPermissionsDialog } from './showReviewAccessPermissionsDialog';
export function showOriginalLocationRemovedDialog(t, storage, functionClient, fileName, fileEntityType, fileId, onSuccess) {
    showConfirmDialog({
        title: t('restoreFileDialog.restoredFailedTitle', { fileName }),
        content: t('locationRemovedDialog.content', { fileEntityType: fileEntityType.toLowerCase() }),
        confirmLabel: t('common.continue'),
        onConfirm: () => showDirectoryTreeDialog({
            showRootDirectory: true,
            title: t('documentPanel.selectNewLocation'),
            onChange: (directory) => __awaiter(this, void 0, void 0, function* () {
                const fileExists = yield storage.isFileExists({ name: fileName, parentId: directory === null || directory === void 0 ? void 0 : directory.id });
                if (fileExists.exists) {
                    showFileExistsDialog(t, fileName, fileEntityType);
                }
                else {
                    showReviewAccessPermissionsDialog({
                        onContinue: () => restoreFile(functionClient, fileEntityType, onSuccess, fileId, directory === null || directory === void 0 ? void 0 : directory.id),
                        action: 'restore',
                    });
                }
            }),
        }),
    });
}
